<template>
  <div class="config-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="gotohome">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <span class="nav-title">参数设置</span>
      </template>
    </van-nav-bar>

    <div class="content-area">
      <van-tabs v-model="activeTab" color="#2dd4bf" title-active-color="#0d9488" class="crystal-tabs">
        <van-tab title="补水设置">
          <div class="tab-content">
            <div class="config-block">
              <div class="config-item">
                <span class="config-label">独立补水开关</span>
                <van-switch v-model="evap_enable" size="22" />
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">检查间隔（分钟）</span>
                <div class="config-stepper">
                  <van-stepper v-model="evap_interval_min" min="1" max="1440" step="1" integer />
                </div>
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <div class="label-col">
                  <span class="config-label">独立补水超时（分钟）</span>
                  <span class="label-tip">仅用于独立补水，0 = 关闭保护</span>
                </div>
                <div class="config-stepper">
                  <van-stepper v-model="fill_timeout_min" min="0" max="60" step="1" integer />
                </div>
              </div>
            </div>
            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存补水设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>

        <van-tab title="换水设置">
          <div class="tab-content">
            <div class="config-block">
              <!-- 换水计划: 决定什么时候换水, 3 选项点击弹出选择器 -->
              <div class="config-item" @click="openPlanPicker">
                <span class="config-label">换水计划</span>
                <div class="time-picker-trigger">
                  <span class="time-picker-text">{{ planText }}</span>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M11 5L7 9L3 5" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
              <div class="config-divider"></div>
              <!-- 排水模式: KD-4 比 KD-6 多一个"定时"(抽满时长即完成) -->
              <div class="config-item">
                <span class="config-label">排水模式</span>
                <div class="config-select">
                  <van-radio-group v-model="drain_mode" direction="horizontal">
                    <van-radio :name="0" class="crystal-radio">区间</van-radio>
                    <van-radio :name="1" class="crystal-radio">定时</van-radio>
                    <van-radio :name="2" :disabled="!flow_enable" class="crystal-radio">定量</van-radio>
                  </van-radio-group>
                </div>
              </div>
              <!-- 定量排水时才显示目标量, 步进器直接显示升数 -->
              <template v-if="drain_mode === 2">
                <div class="config-divider"></div>
                <div class="config-item">
                  <div class="label-col">
                    <span class="config-label">定量排水量（升）</span>
                    <span class="label-tip">{{ drainTargetTip }}</span>
                  </div>
                  <div class="config-stepper stepper-with-unit">
                    <van-stepper v-model="drain_target_l" :min="0.1" :max="999.9" :step="0.1"
                      :decimal-length="1" />
                    <span class="stepper-unit">L</span>
                  </div>
                </div>
              </template>
            </div>
            <div class="config-hint">
              换水计划决定什么时候启动换水；排水模式决定排多少水，两者需分别设置。
            </div>

            <!-- 间隔计划: 仅"间隔换水"时显示 -->
            <div class="config-block" v-if="wc_mode === 0">
              <div class="config-item">
                <span class="config-label">换水间隔（小时）</span>
                <div class="config-stepper">
                  <van-stepper v-model="wc_interval_h" min="1" max="720" step="1" integer />
                </div>
              </div>
            </div>

            <!-- 预约设置(定时预约): 默认折叠, 行尾独立开关, 点击展开详细设置 -->
            <div class="config-block" v-if="wc_mode === 1">
              <div class="block-title">预约设置</div>
              <template v-for="g in [0, 1, 2]">
                <div :key="'rd' + g" v-if="g > 0" class="config-divider"></div>
                <div :key="'rg' + g" class="rtc-row">
                  <div class="rtc-row-main" @click="toggleRtcExpand(g)">
                    <span class="rtc-row-name">预约{{ g + 1 }}</span>
                    <span class="rtc-row-summary" :class="{ 'rtc-row-summary--unset': rtcSummary(g) === '未设置' }">
                      {{ rtcSummary(g) }}
                    </span>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                      :style="{ transform: expandedRtc === g ? 'rotate(90deg)' : 'none', transition: 'transform .2s' }">
                      <path d="M5 3L9 7L5 11" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                  <van-switch :value="scheds[g].enable" size="20" @change="setSchedEnable(g, $event)"
                    class="rtc-row-switch" />
                </div>
                <!-- 展开的详细设置: 星期单选(含每天) + 时间 -->
                <div v-if="expandedRtc === g" :key="'re' + g" class="rtc-detail">
                  <div class="config-divider"></div>
                  <div class="config-item config-item--full">
                    <div class="config-weekdays" :class="{ 'config-weekdays--8': !schedMask }">
                      <span v-for="opt in weekdayOptions" :key="'wd' + g + opt.idx" class="weekday-tag"
                        :class="{ 'weekday-active': isWeekdayActive(g, opt.idx) }"
                        @click="onWeekdayClick(g, opt.idx)">
                        {{ opt.label }}
                      </span>
                    </div>
                  </div>
                  <div class="config-divider"></div>
                  <div class="config-item">
                    <span class="config-label">时间</span>
                    <div class="time-picker-trigger" @click="openTimePicker(g)">
                      <span class="time-picker-text">{{ schedTimeDisplay(g) }}</span>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M11 5L7 9L3 5" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                </div>
              </template>
              <div class="config-hint">{{ schedHint }}</div>
            </div>

            <!-- 安全时间: 排水超时/时长与换水补水超时统一放这里, 0=关闭 -->
            <div class="config-block">
              <div class="block-title">安全时间</div>
              <div class="config-item">
                <div class="label-col">
                  <span class="config-label">{{ drainTimeoutLabel }}</span>
                  <span class="label-tip">{{ drainTimeoutTip }}</span>
                </div>
                <div class="config-stepper">
                  <van-stepper v-model="drain_timeout_min" :min="drain_mode === 1 ? 1 : 0" max="60" step="1"
                    integer />
                </div>
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <div class="label-col">
                  <span class="config-label">换水补水超时（分钟）</span>
                  <span class="label-tip">换水补水 / 手动补水，0 = 关闭保护</span>
                </div>
                <div class="config-stepper">
                  <van-stepper v-model="wc_fill_timeout_min" min="0" max="60" step="1" integer />
                </div>
              </div>
              <div class="config-hint">设置为 0 表示关闭超时保护</div>
            </div>

            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存换水设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>

        <van-tab title="系统设置">
          <div class="tab-content">
            <div class="config-block">
              <div class="config-item">
                <div class="label-col">
                  <span class="config-label">维护时长（分钟）</span>
                  <span class="label-tip">0 = 一直维护</span>
                </div>
                <div class="config-stepper">
                  <van-stepper v-model="maint_duration_min" min="0" max="1440" step="1" integer />
                </div>
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">蜂鸣器报警</span>
                <van-switch v-model="buzzer_enable" size="22" />
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <div class="label-col">
                  <span class="config-label">流量计</span>
                  <span class="label-tip">启用后统计每次排水量（升）</span>
                </div>
                <van-switch v-model="flow_enable" size="22" />
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <div class="label-col">
                  <span class="config-label">每升脉冲数</span>
                  <span class="label-tip">按流量计型号标定值填写</span>
                </div>
                <div class="config-stepper">
                  <van-stepper v-model="flow_pulses_per_l" min="1" max="65535" step="1" integer />
                </div>
              </div>
            </div>
            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存系统设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <van-popup v-model="showTimePicker" position="bottom" round>
      <van-datetime-picker v-model="timePickerCurrent" type="time" :min-hour="0" :max-hour="23" :min-minute="0"
        :max-minute="59" @confirm="onTimeConfirm" @cancel="showTimePicker = false" />
    </van-popup>

    <van-popup v-model="showPlanPicker" position="bottom" round>
      <van-picker ref="planPicker" show-toolbar title="换水计划" :columns="planColumns" @confirm="onPlanConfirm"
        @cancel="showPlanPicker = false" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "KD4Config",
  data() {
    return {
      activeTab: 0,
      did: this.$route.query.did,
      weekdays: ["一", "二", "三", "四", "五", "六", "日"],
      /* 独立补水 */
      evap_enable: false,
      evap_interval_min: 30,
      /* 换水计划 0间隔/1定时预约/2仅手动 */
      wc_mode: 2,
      wc_interval_h: 24,
      scheds: [
        { enable: false, weekday: 0, hour: 0, minute: 0 },
        { enable: false, weekday: 0, hour: 0, minute: 0 },
        { enable: false, weekday: 0, hour: 0, minute: 0 },
      ],
      /* 超时保护 */
      fill_timeout_min: 3,
      drain_timeout_min: 10,
      /* 排水模式 0区间(固件排空至低水位)/1定时/2定量；drain_target_l 步进器直接显示升数（0.1~999.9L） */
      drain_mode: 0,
      drain_target_l: 10,
      /* 设备能力：心跳 config.sched_mask=1 → 预约星期位掩码多选；无字段 → 旧固件单选(0=每天/1~7) */
      schedMask: false,
      wc_fill_timeout_min: 0,
      /* 系统 */
      maint_duration_min: 30,
      buzzer_enable: true,
      flow_enable: false,
      flow_pulses_per_l: 450,
      loading: false,
      showTimePicker: false,
      currentSchedGroup: 0,    /* 时间选择器当前编辑的预约组 0~2 */
      timePickerCurrent: "08:00",
      showPlanPicker: false,   /* 换水计划选择弹窗 */
      planColumns: [{ values: ["间隔换水", "定时预约", "仅手动"] }],
      expandedRtc: null,       /* 当前展开详细设置的预约组 0~2, null=全部折叠 */
    };
  },
  computed: {
    /* 换水计划当前值文案 */
    planText() {
      var i = Number(this.wc_mode);
      return this.planColumns[0].values[i] || this.planColumns[0].values[0];
    },
    /* 星期标签列表：多选(新固件)=一~日(idx=位号)；单选(旧固件)=每天+一~日(idx 0=每天,1~7) */
    weekdayOptions() {
      if (this.schedMask) {
        return this.weekdays.map(function (d, i) { return { label: d, idx: i }; });
      }
      var full = ["每天"].concat(this.weekdays);
      return full.map(function (d, i) { return { label: d, idx: i }; });
    },
    schedHint() {
      return this.schedMask
        ? "每组需打开右侧开关、并至少选中一天，才会按时执行；关闭的组只保留星期和时间，标注「未启用」。"
        : "每组需打开右侧开关并选好执行日（可选每天），关闭的组标注「未启用」。";
    },
    /* 定量排水提示：流量计未启用时设备运行按区间执行（固件回退保护） */
    drainTargetTip() {
      return this.flow_enable
        ? "按流量计计量抽到目标量"
        : "流量计未启用，运行时将按区间执行";
    },
    drainTimeoutLabel() {
      return this.drain_mode === 1 ? "排水时长（分钟）" : "排水超时（分钟）";
    },
    drainTimeoutTip() {
      if (this.drain_mode === 1) return "抽满此时长即正常结束";
      if (this.drain_mode === 2) return "定量抽水的超时保护，0 = 关闭";
      return "水位到低位即停，超时报警，0 = 关闭";
    },
  },
  watch: {
    drain_mode(val) {
      /* 流量计未启用时不允许定量排水；定时模式时长不能为 0（会永不结束） */
      if (val === 2 && !this.flow_enable) {
        this.drain_mode = 0;
        this.$toast("流量计未启用，定量排水不可用");
      } else if (val === 1 && this.drain_timeout_min < 1) {
        this.drain_timeout_min = 10;
      }
    },
  },
  methods: {
    /* 预约组折叠行摘要: 按能力模式显示星期 + 时间; 未选星期不会执行须显式提示 */
    rtcSummary(g) {
      var s = this.scheds[g];
      var on = s.enable;
      var wd = Number(s.weekday) || 0;
      var p = function (n) { n = Number(n) || 0; return n < 10 ? "0" + n : "" + n; };
      var text;
      if (this.schedMask) {
        var dayNames = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
        if (!wd) return on ? "未选星期·不会执行" : "未设置";
        var names = [];
        for (var i = 0; i < 7; i++) {
          if ((wd >> i) & 1) names.push(dayNames[i]);
        }
        text = names.join("、") + " " + p(s.hour) + ":" + p(s.minute);
      } else {
        var dayNames1 = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
        var day = wd === 0 ? "每天" : (dayNames1[wd - 1] || "未设星期");
        text = day + " " + p(s.hour) + ":" + p(s.minute);
      }
      if (!on) text += "（未启用）";
      return text;
    },
    /* 点击行展开/折叠详细设置 */
    toggleRtcExpand(g) {
      this.expandedRtc = this.expandedRtc === g ? null : g;
    },
    /* 指定预约组的时间显示 时:分 */
    schedTimeDisplay(g) {
      var p = (n) => (n < 10 ? "0" + n : "" + n);
      return p(this.scheds[g].hour) + ":" + p(this.scheds[g].minute);
    },
    /* 打开时间选择器并记录当前编辑的预约组 */
    openTimePicker(g) {
      this.currentSchedGroup = g;
      this.timePickerCurrent = this.schedTimeDisplay(g);
      this.showTimePicker = true;
    },
    onTimeConfirm() {
      var parts = String(this.timePickerCurrent).split(":");
      var s = this.scheds[this.currentSchedGroup];
      s.hour = parseInt(parts[0], 10) || 0;
      s.minute = parseInt(parts[1], 10) || 0;
      this.showTimePicker = false;
    },
    /* 预约组星期选择：按设备能力分流（位掩码多选 / 旧固件单选） */
    isWeekdayActive(g, idx) {
      var wd = Number(this.scheds[g].weekday) || 0;
      return this.schedMask ? ((wd >> idx) & 1) === 1 : wd === idx;
    },
    onWeekdayClick(g, idx) {
      var s = this.scheds[g];
      if (this.schedMask) {
        s.weekday = (Number(s.weekday) || 0) ^ (1 << idx);
      } else {
        s.weekday = idx;
      }
    },
    setSchedEnable(g, val) {
      this.scheds[g].enable = val;
    },
    /* 换水计划选择: 打开时定位到当前值 */
    openPlanPicker() {
      this.showPlanPicker = true;
      var idx = Number(this.wc_mode);
      if (!(idx >= 0 && idx < this.planColumns[0].values.length)) idx = 0;
      var self = this;
      this.$nextTick(function () {
        var picker = self.$refs.planPicker;
        if (picker) picker.setIndexes([idx]);
      });
    },
    onPlanConfirm(values) {
      var idx = this.planColumns[0].values.indexOf(values[0]);
      if (idx >= 0) this.wc_mode = idx;
      this.showPlanPicker = false;
    },
    GetConfig() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: this.did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            var c = response.data.config;
            if (c) {
              this.evap_enable = c.evap_enable == 1;
              this.evap_interval_min = c.evap_interval_min != null ? c.evap_interval_min : 30;
              this.wc_mode = c.wc_mode != null ? c.wc_mode : 2;
              this.wc_interval_h = c.wc_interval_h != null ? c.wc_interval_h : 24;
              for (var i = 0; i < 3; i++) {
                var s = c["sched" + (i + 1)];
                if (s) {
                  /* $set：按下标替换数组元素 Vue2 侦听不到，新对象不响应式，
                   * 会导致点击星期/开关/时间后界面不更新 */
                  this.$set(this.scheds, i, {
                    enable: s.enable == 1,
                    weekday: s.weekday != null ? s.weekday : 0,
                    hour: s.hour != null ? s.hour : 0,
                    minute: s.minute != null ? s.minute : 0,
                  });
                }
              }
              this.fill_timeout_min = c.fill_timeout_min != null ? c.fill_timeout_min : 3;
              this.drain_timeout_min = c.drain_timeout_min != null ? c.drain_timeout_min : 10;
              this.drain_mode = c.drain_mode != null ? c.drain_mode : 0;
              /* 设备 0.1L 单位 → 步进器升数（0.1~999.9L） */
              this.drain_target_l = c.drain_target != null ? Math.round(c.drain_target) / 10 : 10;
              this.wc_fill_timeout_min = c.wc_fill_timeout_min != null ? c.wc_fill_timeout_min : 0;
              this.maint_duration_min = c.maint_duration_min != null ? c.maint_duration_min : 30;
              this.buzzer_enable = c.buzzer_enable != null ? (c.buzzer_enable == 1) : true;
              this.flow_enable = c.flow_enable != null ? (c.flow_enable == 1) : false;
              this.flow_pulses_per_l = c.flow_pulses_per_l != null ? c.flow_pulses_per_l : 450;
              /* 设备能力：心跳 config 带 sched_mask=1 → 星期多选；无字段 → 旧固件单选 */
              this.schedMask = c.sched_mask == 1;
            }
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    saveConfig() {
      this.loading = true;
      const qs = require("qs");
      var configData = {};
      if (this.activeTab === 0) {
        configData = {
          evap_enable: this.evap_enable ? 1 : 0,
          evap_interval_min: this.evap_interval_min,
          fill_timeout_min: this.fill_timeout_min,
        };
      } else if (this.activeTab === 1) {
        configData = {
          wc_mode: this.wc_mode,
          wc_interval_h: this.wc_interval_h,
          drain_timeout_min: this.drain_timeout_min,
          drain_mode: this.drain_mode,
          /* 升数 → 设备 0.1L 单位（如 12.5L → 125） */
          drain_target: Math.round(this.drain_target_l * 10),
          wc_fill_timeout_min: this.wc_fill_timeout_min,
          /* 预约3组：开关/星期/时/分 */
          sched1: {
            enable: this.scheds[0].enable ? 1 : 0,
            weekday: this.scheds[0].weekday,
            hour: this.scheds[0].hour,
            minute: this.scheds[0].minute,
          },
          sched2: {
            enable: this.scheds[1].enable ? 1 : 0,
            weekday: this.scheds[1].weekday,
            hour: this.scheds[1].hour,
            minute: this.scheds[1].minute,
          },
          sched3: {
            enable: this.scheds[2].enable ? 1 : 0,
            weekday: this.scheds[2].weekday,
            hour: this.scheds[2].hour,
            minute: this.scheds[2].minute,
          },
        };
      } else if (this.activeTab === 2) {
        configData = {
          maint_duration_min: this.maint_duration_min,
          buzzer_enable: this.buzzer_enable ? 1 : 0,
          flow_enable: this.flow_enable ? 1 : 0,
          flow_pulses_per_l: this.flow_pulses_per_l,
        };
      }
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.did,
          d_type: "KD-4",
          config: JSON.stringify(configData),
        }))
        .then((response) => {
          this.loading = false;
          if (response.data.error_code === 0) {
            this.$toast.success("设置已保存");
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$toast.fail("保存失败");
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.fail("保存失败");
        });
    },
    gotohome() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.GetConfig();
  },
};
</script>

<style>
.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.crystal-tabs .van-tabs__wrap {
  background: #ffffff;
}

.crystal-tabs .van-tab {
  font-weight: 500;
}

.crystal-radio .van-radio__label {
  font-size: 13px;
}
</style>

<style scoped>
.config-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
}

.content-area {
  padding: 12px;
}

.tab-content {
  padding-top: 8px;
}

.config-block {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  overflow: hidden;
}

.config-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  min-height: 22px;
  gap: 12px;
}

.config-item--full {
  justify-content: center;
  padding: 14px 12px;
}

.config-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  flex-shrink: 0;
}

.label-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.label-tip {
  font-size: 11px;
  color: #94a3b8;
}

.config-stepper {
  flex-shrink: 0;
}

/* 步进器后置单位（定量排水量 X.XL） */
.stepper-with-unit {
  display: flex;
  align-items: center;
  gap: 6px;
}

.stepper-unit {
  font-size: 13px;
  font-weight: 600;
  color: #0d9488;
  min-width: 44px;
}

.config-select {
  flex-shrink: 0;
}

.config-weekdays {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 320px;
  gap: 4px;
}

/* 旧固件单选模式：8 个标签（每天+一~日）自适应宽度 */
.config-weekdays--8 {
  max-width: 340px;
}

.config-weekdays--8 .weekday-tag {
  flex: 1;
  width: auto;
  min-width: 0;
  padding: 0 2px;
}

.weekday-tag {
  width: 36px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  background: #f1f5f9;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.weekday-tag:active {
  transform: scale(0.9);
}

.weekday-active {
  background: #2dd4bf;
  color: #fff;
  box-shadow: 0 2px 6px rgba(45, 212, 191, 0.25);
}

/* 区块标题 (预约设置/安全时间) */
.block-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  padding: 12px 16px 2px;
}

/* 预约折叠行: 名称+摘要+箭头, 行尾独立开关 */
.rtc-row {
  display: flex;
  align-items: center;
  padding: 8px 12px 8px 16px;
}

.rtc-row-main {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  cursor: pointer;
}

.rtc-row-name {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  flex-shrink: 0;
}

.rtc-row-summary {
  flex: 1;
  font-size: 13px;
  color: #334155;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rtc-row-summary--unset {
  color: #94a3b8;
}

.rtc-row-switch {
  flex-shrink: 0;
  margin-left: 10px;
}

.rtc-detail {
  padding-bottom: 4px;
}

.config-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

.config-hint {
  padding: 8px 16px 12px;
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.5;
}

.config-save-wrap {
  padding: 16px 0 24px;
  display: flex;
  justify-content: center;
}

.save-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.15s, opacity 0.15s;
  box-shadow: 0 4px 12px rgba(45, 212, 191, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.save-btn:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.save-btn-loading {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.time-picker-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s;
  background: #f8fafc;
}

.time-picker-trigger:active {
  border-color: #2dd4bf;
}

.time-picker-text {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  min-width: 44px;
  text-align: center;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}
</style>
